import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import axios from '../../axios';
import logo from '../../img/nekrodruk-logo-dark.png';
import './LoginForm.scss';

const validationSchema = Yup.object({
  email: Yup.string()
    .email('Podaj prawidłowy adres e-mail')
    .required('Adres e-mail jest wymagany'),
});

export default function ForgotPassword() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (values, { setSubmitting }) => {
    setMessage('');
    setError('');

    try {
      const response = await axios.post('/password-reset/request', {
        email: values.email,
      });
      setMessage(response.data.message);
    } catch (requestError) {
      setError(
        requestError.response?.data?.message
          || 'Nie udało się wysłać prośby. Spróbuj ponownie później.',
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box className='LoginForm passwordResetPage'>
      <Paper elevation={0} className='formCard'>
        <Stack spacing={3} alignItems='center'>
          <Box component='img' src={logo} alt='Nekrodruk' className='logo' />
          <Typography component='h1' variant='h4' className='formTitle' align='center'>
            Reset hasła
          </Typography>
          <Typography color='text.secondary' align='center'>
            Podaj adres e-mail konta. Wyślemy na niego link do ustawienia nowego hasła.
          </Typography>

          <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className='formContainer'>
                <Stack spacing={2}>
                  <Field name='email'>
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        type='email'
                        autoComplete='email'
                        label='Adres e-mail'
                        fullWidth
                        error={Boolean(meta.touched && meta.error)}
                        helperText={meta.touched && meta.error ? meta.error : ''}
                      />
                    )}
                  </Field>
                  {message && <Alert severity='success' className='formAlert'>{message}</Alert>}
                  {error && <Alert severity='error' className='formAlert'>{error}</Alert>}
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    disabled={isSubmitting}
                    className='formSubmit'
                  >
                    Wyślij link
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>

          <Link component={RouterLink} to='/login'>
            Wróć do logowania
          </Link>
        </Stack>
      </Paper>
    </Box>
  );
}
